<template>
  <div
    class="annotation-viewport-img-box"
    ref="viewportImg"
    :style="`background-image:url(${viewportImg})`"
    @mousewheel="closeViewportImg"
  >
    <div class="close-icon-box" @click="closeViewportImg">
      <i class="el-icon-close" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    viewportImg: String,
  },
  methods: {
    closeViewportImg() {
      this.$emit("closeAnnotationViewport");
    },
  },
};
</script>

<style lang="less" scoped>
.annotation-viewport-img-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  z-index: 9;

  .close-icon-box {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    color: var(--default-color);
    cursor: pointer;
    padding: 5px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
  }
}
</style>